/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_No_ResultsInputs */

const tr_faq_no_results = /** @type {(inputs: Faq_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç bulunamadı. Farklı bir kelime dene veya destek ekibine yaz.`)
};

const en_faq_no_results = /** @type {(inputs: Faq_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found. Try a different keyword or write to support.`)
};

const de_faq_no_results = /** @type {(inputs: Faq_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse. Probier ein anderes Stichwort oder schreib an Support.`)
};

const ru_faq_no_results = /** @type {(inputs: Faq_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ничего не найдено. Попробуйте другое слово или напишите в поддержку.`)
};

/**
* | output |
* | --- |
* | "No results found. Try a different keyword or write to support." |
*
* @param {Faq_No_ResultsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_no_results = /** @type {((inputs?: Faq_No_ResultsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_No_ResultsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_no_results(inputs)
	if (locale === "de") return de_faq_no_results(inputs)
	if (locale === "ru") return ru_faq_no_results(inputs)
	return tr_faq_no_results(inputs)
});